var _clipPath, _mask, _circle, _circle2, _path, _path2, _path3, _path4, _g, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _g2, _path13, _path14, _path15, _path16, _path17, _circle3, _circle4, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _circle5, _circle6, _path27;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFatigue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 288,
    viewBox: "0 0 640 288",
    width: 640,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m106.239 207.987h69v70h-69z"
  }))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m322.61 198.307h-113l-25.183 68.087h-51.555v4.913h113 49.738z",
    fill: "#fff",
    fillRule: "evenodd"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 179.461,
    cy: 141.106,
    fill: "#f2f2ff",
    r: 112
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 472.619,
    cy: 141.106,
    fill: "#f2f2ff",
    r: 112
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m448.701 105.204h46.541m-46.541 38.154h46.541m-46.541 33.159h46.541",
    stroke: "#a9a6ff",
    strokeLinecap: "round",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m430.773 97.8647c.587-.4216.757-1.2317.36-1.8363l-1.436-2.1897c-.396-.6047-1.208-.7751-1.798-.3566-5.603 3.9767-10.424 9.0859-14.942 14.2379l-4.962-4.962c-.512-.511-1.341-.511-1.852 0l-1.851 1.851c-.512.512-.512 1.341 0 1.852l7.981 7.981c.546.546 1.444.503 1.936-.093 4.91-5.957 10.269-11.965 16.564-16.4843z",
    fill: "#8a85fa",
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m430.773 136.019c.587-.422.757-1.232.36-1.837l-1.436-2.19c-.396-.604-1.208-.775-1.798-.356-5.603 3.977-10.424 9.086-14.942 14.238l-4.962-4.962c-.512-.512-1.341-.512-1.852 0l-1.851 1.851c-.512.511-.512 1.34 0 1.852l7.981 7.981c.546.546 1.444.503 1.936-.093 4.91-5.957 10.269-11.966 16.564-16.484z",
    fill: "#8a85fa",
    fillRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m430.773 173.725c.587-.422.757-1.232.36-1.837l-1.436-2.189c-.396-.605-1.208-.775-1.798-.357-5.603 3.977-10.424 9.086-14.942 14.238l-4.962-4.962c-.512-.511-1.341-.511-1.852 0l-1.851 1.851c-.512.512-.512 1.341 0 1.852l7.981 7.981c.546.546 1.444.503 1.936-.093 4.91-5.957 10.269-11.965 16.564-16.484z",
    fill: "#8a85fa",
    fillRule: "evenodd"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#a9a6ff",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m89.8867 169.7c0-.691.5597-1.25 1.25-1.25h46.4943c.69 0 1.25.559 1.25 1.25v14.261c0 .691-.56 1.25-1.25 1.25h-46.4943c-.6903 0-1.25-.559-1.25-1.25z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m153.243 169.7c0-.691.56-1.25 1.25-1.25h46.494c.691 0 1.25.559 1.25 1.25v14.261c0 .691-.559 1.25-1.25 1.25h-46.494c-.69 0-1.25-.559-1.25-1.25z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m153.243 136.589c0-.69.56-1.25 1.25-1.25h46.494c.691 0 1.25.56 1.25 1.25v14.262c0 .69-.559 1.25-1.25 1.25h-46.494c-.69 0-1.25-.56-1.25-1.25z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    height: 16.7616,
    rx: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    width: 48.9944,
    x: 216.599,
    y: 135.339
  }), /*#__PURE__*/React.createElement("rect", {
    height: 16.7616,
    rx: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    width: 48.9944,
    x: 89.8867,
    y: 135.339
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m89.1367 100.939c0-1.1044.8954-1.9998 2-1.9998h43.3853c.659 0 1.276.3247 1.649.868l5.733 8.3498c.468.682.468 1.582 0 2.264l-5.733 8.35c-.373.544-.99.868-1.649.868h-43.3853c-1.1045 0-2-.895-2-2z",
    fill: "#a9a6ff",
    fillRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m152.493 100.939c0-1.1044.895-1.9998 2-1.9998h42.078c.669 0 1.293.3338 1.664.8896l5.574 8.3502c.449.672.449 1.548 0 2.221l-5.574 8.35c-.371.555-.995.889-1.664.889h-42.078c-1.105 0-2-.895-2-2z",
    fill: "#a9a6ff",
    fillRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m215.849 100.939c0-1.1044.895-1.9998 2-1.9998h42.078c.669 0 1.293.3338 1.664.8896l5.574 8.3502c.448.672.448 1.548 0 2.221l-5.574 8.35c-.371.555-.995.889-1.664.889h-42.078c-1.105 0-2-.895-2-2z",
    fill: "#a9a6ff",
    fillRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m305.256 135.25c-.415 0-.75.336-.75.75s.335.75.75.75zm44.53 1.28c.293-.293.293-.767 0-1.06l-4.773-4.773c-.293-.293-.768-.293-1.061 0s-.293.767 0 1.06l4.243 4.243-4.243 4.243c-.293.293-.293.767 0 1.06s.768.293 1.061 0zm-.53 16.22c.414 0 .75-.336.75-.75s-.336-.75-.75-.75zm-44.531-1.28c-.293.293-.293.767 0 1.06l4.773 4.773c.293.293.768.293 1.061 0s.293-.767 0-1.06l-4.243-4.243 4.243-4.243c.293-.293.293-.767 0-1.06s-.768-.293-1.061 0zm.531-14.72h44v-1.5h-44zm44 14.5h-44v1.5h44z",
    fill: "#8a85fa"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m115.159 79c8.942 0 14.905 1.353 19.376 6.7649 8.295-.1208 10.94 10.5096 10.94 17.1541v25.392c0 13.864-11.239 25.102-25.103 25.102h-52.9112s1.4906-12.176 10.434-20.294c8.9433-8.118 11.9235-12.177 11.9235-28.413 0-20.2941 16.3977-25.706 25.3407-25.706z",
    fill: "#a95b29"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m95.667 145.794-.2107.51h24.2147l.03.118h6.535c19.285 0 35.848 13.707 39.455 32.652l15.984 92.233h-76.406l-66.1416.51c-17.7591 0-29.90278-17.936-23.3073-34.425l.6326-1.582 27.6129-67.422c5.5979-13.669 18.8812-22.594 33.6253-22.594z",
    fill: "#413d99"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m322.61 198.307h-113l-25.183 68.087h-51.555v4.913h113 49.738z",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m209.61 198.307v-1h-.696l-.242.653zm113 0 .938.347.498-1.347h-1.436zm-138.183 68.087v1h.696l.242-.653zm-51.555 0v-1h-1v1zm0 4.913h-1v1h1zm113 0v1h1v-1zm0 0v-1h-1v1zm49.738 0v1h.696l.242-.653zm-86-72h113v-2h-113zm-24.245 67.434 25.183-68.087-1.876-.694-25.183 68.087zm-52.493.653h51.555v-2h-51.555zm1 3.913v-4.913h-2v4.913zm112-1h-113v2h113zm-1 1h2zm50.738-1h-49.738v2h49.738zm26.062-72.347-27 73 1.876.694 27-73z",
    fill: "#c4c2ff",
    mask: "url(#b)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m140.739 270.987c15.243 0 27.6-12.536 27.6-28s-12.357-28-27.6-28-27.6 12.536-27.6 28 12.357 28 27.6 28z",
    fill: "#51c466",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m148.606 234.178c-.652-2.124-3.589-4.358-7.574-4.358-5.03 0-8.16 2.495-8.16 6.284 0 2.527 2.622 4.702 7.867 6.525s7.867 3.998 7.867 6.524c0 3.79-3.13 6.284-8.16 6.284-3.985 0-6.922-2.233-7.574-4.357m8.086-25.53v4.154m0 25.725v4.995",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m148.46 271.307h-43.208v-14.403h28.805c7.954 0 14.403 6.448 14.403 14.403z",
    fill: "#f9d8b8"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m109.473 117.406h-14.4025v48.009c7.9545 0 14.4025-6.448 14.4025-14.402z",
    fill: "#a95b29"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m137.678 95.1229 2.917 21.1471c1.243 9.008-5.718 17.044-14.792 17.119v11.876c0 4.373-3.545 7.918-7.918 7.918-4.372 0-7.917-3.545-7.917-7.917v-30.35c-2.913-.001-5.275-2.364-5.275-5.278s2.362-5.277 5.275-5.278h.003c.994 0 1.924.275 2.718.753 5.038 1.005 10.317-.034 14.632-2.962z",
    fill: "#f9d8b8"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m142.918 113.582-4.641-5.775v8.401l3.856-.6c.954-.148 1.39-1.273.785-2.026z",
    fill: "#f9d8b8"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m110.672 106.605c-1.325 0-2.4 1.074-2.4 2.4s1.075 2.4 2.4 2.4",
    stroke: "#c18959",
    strokeLinecap: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    fill: "#43260e",
    r: 1.20022,
    transform: "matrix(-1 0 0 1 134.675 106.605)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    fill: "#ffb178",
    r: 5.40097,
    transform: "matrix(-1 0 0 1 129.273 114.406)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m463.635 232.91h-.036l30.016-71.809c6.085-14.627 18.084-24.18 34.984-24.179h60.222l.002.004c22.794.301 41.177 18.586 41.177 41.098v70.245c0 12.723-10.477 23.037-23.4 23.037l-46.707.001c-.08 0-.16-.001-.24-.001h-73.081c-18.469 0-31.092-18.372-24.219-35.249z",
    fill: "#413d99"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m541.274 194.685c0-2.209 1.791-4 4-4h63.051c2.209 0 4 1.791 4 4v77.042h-71.051z",
    fill: "#fff"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m591.967 186.245h-8.885c-.915-2.587-3.382-4.441-6.282-4.441s-5.368 1.854-6.282 4.441h-8.885c-1.433 0-2.596 1.162-2.596 2.595v4.959c0 1.434 1.163 2.596 2.596 2.596h30.334c1.433 0 2.595-1.162 2.595-2.596v-4.959c0-1.433-1.162-2.595-2.595-2.595zm-15.167 3.978c1.073 0 1.943-.87 1.943-1.943s-.87-1.943-1.943-1.943-1.943.87-1.943 1.943.87 1.943 1.943 1.943z",
    fill: "#51c466",
    fillRule: "evenodd"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m532.619 271.306h52v-1.622c0-9.156-7.422-16.578-16.578-16.578h-35.422z",
    fill: "#c18959"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m548.303 106.521c-4.802-3.616-8.929-6.5366-11.59-10.7697-2.655-4.2458-3.829-9.798-2.783-15.2373s4.307-10.744 8.952-13.0203c4.656-2.281 10.682-1.5328 17.398-1.451 6.714.0823 14.116-.4991 17.108 2.8381 2.982 3.342 1.568 10.6222.817 16.9685-.765 6.3381-.852 11.7612-3.109 17.0827-2.254 5.334-6.651 10.576-11.591 11.044-4.928.467-10.404-3.848-15.202-7.455z",
    fill: "#43260e"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "m575.422 106.148v9.14c0 5.446-3.347 10.111-8.096 12.048v10.063c0 6.465-5.241 11.706-11.707 11.706-6.465 0-11.706-5.241-11.706-11.706v-10.318c-4.438-2.071-7.513-6.573-7.513-11.793v-9.14c-2.926-.324-5.202-2.805-5.202-5.817 0-3.0132 2.276-5.4943 5.202-5.8179v-.0367h2.602l2.601-15.6087h28.616l2.602 15.6087h2.601v.0366c2.927.3233 5.204 2.8046 5.204 5.818 0 3.013-2.277 5.494-5.204 5.817z",
    fill: "#c18959"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "m542.907 117.89 10.406-5.203c1.507 1.256 3.696 1.256 5.202 0l10.406 5.203c2.155 0 3.903-1.747 3.903-3.902v-7.805c0-1.436 1.164-2.601 2.601-2.601v13.007c0 10.057-8.153 18.21-18.21 18.21h-2.602c-10.057 0-18.21-8.153-18.21-18.21v-13.007c1.437 0 2.602 1.165 2.602 2.601v7.805c0 2.155 1.747 3.902 3.902 3.902z",
    fill: "#43260e"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "m535.238 98.3773c-.718 0-1.3.7765-1.3 1.7347 0 .957.582 1.734 1.3 1.734",
    stroke: "#a95b29",
    strokeLinecap: "round",
    strokeWidth: 0.789865
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "m576.86 98.3773c.719 0 1.301.7765 1.301 1.7347 0 .957-.582 1.734-1.301 1.734",
    stroke: "#a95b29",
    strokeLinecap: "round",
    strokeWidth: 0.789865
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 547.381,
    cy: 98.3778,
    fill: "#43260e",
    r: 1.30073
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 563.858,
    cy: 98.3803,
    fill: "#43260e",
    r: 1.30073
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "m563.052 232.164 6.737 6.647s9.909-12.021 18.082-17.379",
    stroke: "#2aaa51",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFatigue);
export default __webpack_public_path__ + "static/media/fatigue.38e903d631ad10efd0ac0b2352ec7403.svg";
export { ForwardRef as ReactComponent };